import * as Sentry from '@sentry/browser';
import { Icon } from '@teamsnap/snap-ui';
import { LoadingType, useFinancials } from 'hooks/financials';
import * as React from 'react';
import { convertAmountAsPennies } from '../financials-utils';
import InsightToggleTile from '../insights-toggle-tile';

export default function Summary() {
  const {
    depositSummary,
    loading
  } = useFinancials();
  
  if (loading[LoadingType.GetDeposits] || !depositSummary) {
    return (
      <div
        data-testid="deposit-summary-loading"
        className="sui-h-[129px] sui-max-w-[592px] sui-mb-2 sui-bg-neutral-background-weak sui-rounded"
      />
    );
  }
  
  return (
    <section
      data-testid="deposit-summary-section"
      className="sui-bg-neutral-background-weak sui-rounded sui-px-4 sui-py-2 sui-w-fit sui-mb-2"
    >
      <div className="sui-flex sui-gap-4 sui-mb-2">
        <InsightToggleTile
          label="Gross"
          value={convertAmountAsPennies(depositSummary.gross)}
        />
        <InsightToggleTile
          id="failed-payments-insight-toggle"
          label="Net"
          value={convertAmountAsPennies(depositSummary.net)}
        />
        <InsightToggleTile
          label="Fees"
          value={convertAmountAsPennies(depositSummary.fees)}
        />
      </div>

      <p className="sui-flex sui-items-center sui-gap-[4px]">
        <Icon name="info" size="s" className="sui-text-neutral-icon-medium" />
        This information is affected by the Date filter.
      </p>
    </section>
  );
}

